import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { countries } from '@/data/fundsData';
import { ArrowRight } from 'lucide-react';

export const CountriesSection = ({ onNavigate }) => {
  return (
    <section className="py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold text-foreground mb-3">
            Rankings by Region
          </h2>
          <p className="text-muted-foreground font-sans">
            Explore fund performance across different markets
          </p>
        </div>

        <div className="flex justify-center gap-6">
          {countries.map((country) => (
            <Card 
              key={country.id}
              className="card-premium border-border cursor-pointer group w-48"
              onClick={() => onNavigate('rankings')}
            >
              <CardContent className="p-5 text-center">
                <div className="text-4xl mb-3">{country.flag}</div>
                <h3 className="font-serif font-semibold text-foreground mb-1">
                  {country.name}
                </h3>
                <p className="text-xs text-muted-foreground mb-3">
                  Top 10 Funds
                </p>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  className="text-accent hover:text-accent hover:bg-accent/10 p-0 h-auto font-sans text-xs group-hover:underline"
                >
                  View Rankings
                  <ArrowRight className="h-3 w-3 ml-1 transition-transform group-hover:translate-x-1" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
